import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { FormField, TextareaOptions } from '../../types/form';

interface TextareaFieldEditorProps {
  editedField: FormField;
  onFieldChange: (updates: Partial<FormField>) => void;
}

export const TextareaFieldEditor: React.FC<TextareaFieldEditorProps> = ({
  editedField,
  onFieldChange,
}) => {
  const options = (editedField.options || {}) as TextareaOptions;

  return (
    <div>
      <Label htmlFor={`rows-${editedField.id}`}>Rows</Label>
      <Input
        id={`rows-${editedField.id}`}
        type="number"
        value={options.rows || 3}
        onChange={(e) => onFieldChange({ 
          options: { ...editedField.options, rows: parseInt(e.target.value) }
        })}
        min="1"
        max="10"
      />
    </div>
  );
};
